import { api } from './api'

export const exclusionKeywordsService = {
    getAll: () => api.get('/admin/exclusion-keywords'),
    create: (data) => api.post('/admin/exclusion-keywords', data),
    update: (id, data) => api.put(`/admin/exclusion-keywords/${id}`, data),
    remove: (id) => api.delete(`/admin/exclusion-keywords/${id}`),
    previewRescore: () => api.post('/admin/exclusion-keywords/rescore/preview'),
    applyRescore: () => api.post('/admin/exclusion-keywords/rescore/apply'),
}
